import { Info } from '@phosphor-icons/react';
import { withMagneticIcon } from '../withMagneticIcon.js';

const Icon = withMagneticIcon(Info);
Icon.displayName = "Info";

export { Icon as Info };
//# sourceMappingURL=Info.js.map
